<div fxLayout="row" fxLayout.lt-md="column" fxFlex fxLayoutGap="20px">
    <div fxFlex>
      <app-layout-dynamic-data #layoutdynamicdata *ngIf="data" [data]="data" (closeModalReturn)="closeModal($event)" (streamModeReturn)="setStreamMode($event)" (viewModeReturn)="setViewMode($event)" (sessionReturn)="setSessionData($event)" [backLayer]="backLayer"></app-layout-dynamic-data>
    </div>
</div>
